export const INVOICE_TYPE_E_FACTURA = 111;
export const INVOICE_TYPE_E_TICKET = 101;

export const INVOICE_TYPE_OPTIONS = [
  { value: INVOICE_TYPE_E_FACTURA, label: 'e-Factura (con RUT)' },
  { value: INVOICE_TYPE_E_TICKET, label: 'e-Ticket (consumidor final)' },
];

export const INVOICE_TYPE_LABELS = {
  101: 'e-Ticket',
  102: 'NC e-Ticket',
  111: 'e-Factura',
  112: 'NC e-Factura',
  113: 'ND e-Factura',
};

export const DOC_TYPE_OPTIONS = [
  { value: 1, label: 'RUT' },
  { value: 2, label: 'C.I.' },
  { value: 3, label: 'Pasaporte' },
];

export const DOC_TYPE_RUT = 1;
export const DOC_TYPE_CI = 2;

export function getInvoiceTypeLabel(type) {
  return INVOICE_TYPE_LABELS[Number(type)] || type;
}

export function getDefaultDocTypeForInvoiceType(tipoComprobante) {
  return Number(tipoComprobante) === INVOICE_TYPE_E_FACTURA
    ? DOC_TYPE_RUT
    : DOC_TYPE_CI;
}

export function validateInvoiceClient(form) {
  const tipo = Number(form.tipo_comprobante);
  const tipoDoc = Number(form.cliente?.tipo_doc);
  const nroDoc = String(form.cliente?.nro_doc || '').replace(/\D/g, '');
  const denominacion = String(form.cliente?.denominacion || '').trim();

  if (tipo === INVOICE_TYPE_E_FACTURA) {
    if (tipoDoc !== DOC_TYPE_RUT) {
      return 'e-Factura requiere receptor con tipo de documento RUT.';
    }
    if (nroDoc.length !== 12) {
      return 'e-Factura requiere un RUT válido de 12 dígitos.';
    }
    if (!denominacion) {
      return 'e-Factura requiere la denominación del receptor.';
    }
  }

  if (tipo === INVOICE_TYPE_E_TICKET) {
    if (!nroDoc && !denominacion) {
      return 'e-Ticket requiere documento o denominación del consumidor final.';
    }
  }

  return null;
}
